import { createAsyncThunk } from '@reduxjs/toolkit'

import * as api from 'connections/restApi'

export const get = createAsyncThunk('roles/get', async () => {
  const response = await api.getRoles()
  return response
})
